import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NmdCalculationResponseDto, PrintResultDto } from '../../core/services/GPRMV1Service.Generated';
import { DataSetSettingEnum } from '../../shared/enums/data-set-setting.enum';
import { ENmdProductStatus } from '../../shared/enums/nmd-product-status.enum';
import { ValuePerPhaseModel } from '../../shared/models/value-per-phase.model';

@Component({
    selector: 'app-print-mpg-elements',
    templateUrl: './print-mpg-elements.component.html',
    styleUrls: ['./print-mpg-elements.component.scss', '../print-page.component.scss'],
    standalone: false
})
export class PrintMpgElementsComponent {
    @Input() elementResultTitle: string;
    @Input() calculationResults: NmdCalculationResponseDto | null = null;
    @Input() calculationResultsAfter: NmdCalculationResponseDto | null = null;
    @Input() mpgResultTitle: string;
    @Input() isExistingBuildingCal: boolean;
    @Input() selectedDataSet: number;
    @Input() mpgResultTitlePerMainElementTitle: string;
    @Input() printData: PrintResultDto;
    @Input() envirnmentalCategoryTitle: string;
    @Input() environmentEffects: ValuePerPhaseModel[];
    @Input() environmentEffectsAfter: ValuePerPhaseModel[];

    dataSetSetting = DataSetSettingEnum;
    nmdProductStatusEnum = ENmdProductStatus;
    uploadsImageBaseUrl: string = environment.uploadsBaseUrl;

    /**
   * return boolean value if A1 data exists in the item
   */
    hasA1Data(item: any): boolean {
        return item.precalculations?.some(p => p.assessmentStrategyId === DataSetSettingEnum.A1);
    }

    /**
    * return boolean value if A2 data exists in the item
    */
    hasA2Data(item: any): boolean {
        return item.precalculations?.some(p => p.assessmentStrategyId === DataSetSettingEnum.A2);
    }
}
